import { APP_INITIALIZER, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitterModule } from 'primeng/splitter';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { CheckboxModule } from 'primeng/checkbox';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LocalizationService } from '../../services/localization.service';
import { LocalizationServiceConfig } from '../../services/localization-config.service';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { FileUploadModule } from 'primeng/fileupload';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ColorPickerModule } from 'primeng/colorpicker';
import { NgChartsModule } from 'ng2-charts';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { ChipsModule } from 'primeng/chips';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MultiSelectModule } from 'primeng/multiselect';
import { RatingModule } from 'primeng/rating';
import { MatToolbarModule } from '@angular/material/toolbar';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SplitterModule,
        TabViewModule,
        TableModule,
        FormsModule,
        CheckboxModule,
        ToolbarModule,
        ButtonModule,
        RippleModule,
        DialogModule,
        SkeletonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTooltipModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ToastModule,
        PickerModule,
        FileUploadModule,
        DropdownModule,
        ConfirmDialogModule,
        ColorPickerModule,
        NgChartsModule,
        MatCheckboxModule,
        ChipsModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MultiSelectModule,
        RatingModule,
        MatToolbarModule,
    ], exports: [
        CommonModule,
        SplitterModule,
        TabViewModule,
        TableModule,
        FormsModule,
        CheckboxModule,
        ToolbarModule,
        ButtonModule,
        RippleModule,
        DialogModule,
        SkeletonModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatRippleModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTooltipModule,
        MatTableModule,
        MatDatepickerModule,
        MatNativeDateModule,
        TranslateModule,
        ToastModule,
        PickerModule,
        FileUploadModule,
        DropdownModule,
        ConfirmDialogModule,
        ColorPickerModule,
        NgChartsModule,
        MatCheckboxModule,
        ChipsModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatIconModule,
        MultiSelectModule,
        RatingModule,
        MatToolbarModule,
    ],
    providers: [
        MessageService,
        ConfirmationService
    ]
})
export class NjoyCommonModule {
    public static forRoot(config: any): ModuleWithProviders<NjoyCommonModule> {
        return {
            ngModule: NjoyCommonModule,
            providers: [
                {
                    provide: APP_INITIALIZER,
                    useFactory: initLocalizationService,
                    deps: [LocalizationService],
                    multi: true
                },
                LocalizationService,
                { provide: LOCALE_ID, useValue: config.locale_id }, // using the initial value
                { provide: LocalizationServiceConfig, useValue: config }
            ]
        };
    }
}

/**
 * Initialize the localization service.
 * @param {LocalizationService} service
 * @returns {() => Promise<void>}
 */
export function initLocalizationService(service: LocalizationService) {
    return () => service.initService();
}
